/* eslint-disable */
import { Dialog } from "@material-ui/core";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { CloseIcon } from "../../../../assets/Icons";
import {
  addOfflineRecipient,
  initializeTransaction,
  uploadDocs,
  uploadUTRNumber,
  uploadOfflineDocument,
} from "../../../../services/offline";
import { offlineWesternUnion } from "../../../../store";
import Button from "../../../../components/ui/Button";

export const OfflineWUDocuments = () => {
  const fieldStyle = "text-black text-[18px] font-ssp font-semibold";
  const inputStyle = "mx-5 my-3 px-5 py-3 rounded-md border-2 border-gray-300 bg-blue-100";
  const [studentName, setStudentName] = useState<string>("");
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const offlineRemitter = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");
  const [utrNo, setUtrNo] = useState<string>("");
  const [finalModal, showFinalModal] = useState<boolean>(false);
  const [uploadOne, setUploadOne] = useState<boolean>(false);
  const [uploadTwo, setUploadTwo] = useState<boolean>(false);
  const [transactionID, setTransactionID] = useState<string>("");
  const [uploadFileOne, setUploadFileOne] = useState();
  const [uploadFileTwo, setUploadFileTwo] = useState();
  const [passportUploaded, setPassportUploaded] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [offerUploaded, setOfferUploaded] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  const [uploadedFileData, setUploadedFileData] = useState({
    fileName: "",
    uploadedFile: "",
  });
  const [offlineWUData, setOfflineWuData] = useRecoilState(offlineWesternUnion);

  useEffect(() => {
    if (uploadFileOne) {
      const fileOne: any = new FormData();
      fileOne.append("file", uploadFileOne);
      fileOne.append("doc_type".toLowerCase());
      uploadDocs(currentUser, transactionID, fileOne);
      const fileTwo: any = new FormData();
      fileTwo.append("file", uploadFileTwo);
      fileTwo.append("doc_type".toLowerCase());
      uploadDocs(currentUser, transactionID, fileTwo);
    } else if (uploadFileTwo) {
      const fileTwo: any = new FormData();
      fileTwo.append("file", uploadFileTwo);
      fileTwo.append("doc_type".toLowerCase());
      uploadDocs(currentUser, transactionID, fileTwo);
    }
  }, [transactionID]);

  window.console.log("offline western union", offlineWUData);

  const handleFinalNext = () => {
    setIsLoading(true);
    const body = {
      firstName: studentName,
      middleName: "",
      nickName: "",
      lastName: "",
      relationship: "",
      sortCode: "",
      swiftCode: "",
      bsbCode: "",
      achCode: "",
      ibanCode: "",
      bankAccountNumber: offlineWUData?.bankAccountNumber
        ? offlineWUData?.bankAccountNumber
        : "N/A",
      countryofResidence: "",
      recipientAddress: "",
      unitNumber: "",
      city: "",
      phoneNumber: "",
      pinCode: "",
      transitCode: "",
      state: "",
      recipientLs: "",
      bankAccountCountry: "",
      currency: "",
      refrence: offlineWUData?.reference,
      ifscCode: "",
      bankCode: "",
      email: "",
      bankName: offlineWUData?.bankName ? offlineWUData?.bankName : "N/A",
      offline: true,
    };
    addOfflineRecipient(offlineRemitter, currentUser, body)
      .then((response) => {
        const body = {
          ...offlineWUData,
          base_currency: "INR",
          dest_currency: offlineWUData.dest_currency ? offlineWUData.dest_currency : "USD",
          hop_fees: offlineWUData?.hop_fees,
          total_pay: offlineWUData.total_pay,
          user_send: offlineWUData?.user_send,
          transaction_purpose: "Overseas Education - Living Expenses",
          purposeCode: "S0305",
          transactionLeadIds: Object.values(offlineWUData?.transactionLeadIds),
          isAdvancePay: false,
          isFullPay: true,
          hop_coins: 0,
          isEducation: true,
          id_recipient: response?.data?.id,
          vendor_key: currentUser.vendor_key,
          referrerVendor: offlineWUData?.reference,
          isDualTransaction: false,
          bankName: offlineWUData.bankName,
          accNumber: offlineWUData.bankAccountNumber,
          modeOfTransaction: "WesternUnion",
        };
        initializeTransaction(offlineRemitter, currentUser, body)
          .then((response) => {
            showFinalModal(true);
            setTransactionID(response?.data?.transactionNumber);
            uploadUTRNumber(currentUser, {
              transaction_num: response?.data?.transactionNumber,
              reference: utrNo,
            });
          })
          .catch((error) => {
            setErrorMessage(error?.response?.data?.error?.type);
          });
      })
      .catch((error) => {
        setErrorMessage(error?.response?.data?.error?.type);
      })
      .finally(() => setIsLoading(false));
  };

  const uploadOfflineLoanLetter = async (e: any, type: string) => {
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    data.append("file", fileData);
    await uploadOfflineDocument(currentUser, data, type)
      .then((response) => {
        if (response.data.success === true) {
          setUploadedFileData({
            fileName: e.target.files[0].name,
            uploadedFile: URL.createObjectURL(e.target.files[0]),
          });

          if (type === "Student-Passport") {
            setOfflineWuData({
              ...offlineWUData,
              transactionLeadIds: {
                ...offlineWUData.transactionLeadIds,
                offlineStudentPassport: response.data.leadDocId,
              },
            });
            setPassportUploaded(true);
          } else if (type === "University-Offer-Letter") {
            setUploadOne(true);
            setOfflineWuData({
              ...offlineWUData,
              transactionLeadIds: {
                ...offlineWUData.transactionLeadIds,
                offlineUniOfferLetter: response.data.leadDocId,
              },
            });
            setOfferUploaded(true);
          } else if (type === "Student-Pan") {
            setUploadTwo(true);
            setOfflineWuData({
              ...offlineWUData,
              transactionLeadIds: {
                ...offlineWUData.transactionLeadIds,
                offlinePAN: response.data.leadDocId,
              },
            });
          } else if (type === "Payment-Confirmation") {
            setOfflineWuData({
              ...offlineWUData,
              transactionLeadIds: {
                ...offlineWUData.transactionLeadIds,
                offlinePaymentConfirmation: response.data.leadDocId,
              },
            });
          } else if (type === "Loan-Sanction-letter") {
            setOfflineWuData({
              ...offlineWUData,
              transactionLeadIds: {
                ...offlineWUData.transactionLeadIds,
                offlineLoanLetter: response.data.leadDocId,
              },
            });
          } else if (type === "Instruction-Sheet") {
            setOfflineWuData({
              ...offlineWUData,
              transactionLeadIds: {
                ...offlineWUData.transactionLeadIds,
                offlineInstructionSheet: response.data.leadDocId,
              },
            });
          }
        }
      })
      .catch((err) => {
        setErrorMessage(err?.response?.data?.error?.type);
        if (type === "Student-Passport") {
          setPassportUploaded(false);
        } else if (type === "University-Offer-Letter") {
          setOfferUploaded(false);
        }
      });
  };

  const checkStatus = () => {
    return !(studentName && passportUploaded && offerUploaded);
  };

  return (
    <div>
      <div id="wrapper" className="flex flex-col items-center">
        <div
          id="topBanner"
          onClick={() => navigate("/home")}
          className="p-6 ml-[1430px] mt-2 hover:scale-150 cursor-pointer transition-all"
        >
          <CloseIcon />
        </div>
        <div id="body" className="flex w-full px-5 mt-10">
          <div className="flex flex-col w-1/2 px-5 mr-2 border-r-2">
            <span className="font-bold text-[35px]">Supporting Document</span>
            <div id="docs" className="flex flex-col mt-10 space-y-7">
              <div id="name" className="flex flex-col">
                <span className={fieldStyle}>
                  Student Name <span className="text-red-100 font-bold">*</span>
                </span>
                <input
                  value={studentName}
                  onChange={(e: any) => setStudentName(e.target.value)}
                  placeholder="Enter Name"
                  className={inputStyle}
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
              <div id="passport" className="flex items-center justify-between w-full">
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">
                    Passport <span className="text-red-100 font-bold">*</span>
                  </span>
                </div>
                <input
                  accept="/*"
                  type="file"
                  className="w-[200px]"
                  onChange={(e: any) => uploadOfflineLoanLetter(e, "Student-Passport")}
                />
              </div>
              <div id="univOfferLe" className="flex items-center justify-between w-full">
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">
                    Univeristy Offer Letter <span className="text-red-100 font-bold">*</span>
                  </span>
                </div>
                <input
                  accept="/*"
                  type="file"
                  className="w-[200px]"
                  onChange={(e: any) => uploadOfflineLoanLetter(e, "University-Offer-Letter")}
                />
              </div>
              <div id="instSheet" className="flex items-center justify-between w-full">
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">
                    Loan Disbursement Letter{" "}
                    <span className="text-primary text-[12px]">(if any)</span>
                  </span>
                </div>
                <input
                  accept="/*"
                  type="file"
                  className="w-[200px]"
                  onChange={(e: any) => uploadOfflineLoanLetter(e, "Loan-Sanction-letter")}
                />
              </div>
              <div id="pan" className="flex items-center justify-between w-full">
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">PAN</span>
                </div>
                <input
                  accept="/*"
                  type="file"
                  className="w-[200px]"
                  onChange={(e: any) => uploadOfflineLoanLetter(e, "Student-Pan")}
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col w-1/2 px-5">
            <span className="font-bold text-[35px]">Payment Details</span>
            <div>
              <div
                id="otherDocBox"
                className="flex flex-col items-center justify-between px-5 py-4 mt-12 space-y-8 border border-gray-400 rounded-xl"
              >
                <div id="instSheet" className="flex items-center justify-between w-full">
                  <div className="flex items-center space-x-10">
                    <span className="font-semibold font-ssp text-[22px]">
                      Instruction Sheet <span className="text-primary text-[12px]">(if any)</span>
                    </span>
                  </div>
                  <input
                    accept="/*"
                    type="file"
                    className="w-[200px]"
                    onChange={(e: any) => uploadOfflineLoanLetter(e, "Instruction-Sheet")}
                  />
                </div>
                <div id="payconfirm" className="flex items-center justify-between w-full">
                  <div className="flex items-center space-x-10">
                    <span className="font-semibold font-ssp text-[22px]">Payment Confirmation</span>
                  </div>
                  <input
                    accept="/*"
                    type="file"
                    className="w-[200px]"
                    onChange={(e: any) => uploadOfflineLoanLetter(e, "Payment-Confirmation")}
                  />
                </div>
                <div className="flex items-center justify-between w-full">
                  <span className="font-semibold font-ssp text-[22px]">Payment UTR No.</span>
                  <input
                    // value={utrNo}
                    onChange={(e: any) => setUtrNo(e.target.value)}
                    placeholder="Enter UTR Number"
                    className="px-5 py-3 mx-5 my-3 bg-blue-100 border-2 border-gray-300 w-[400px] rounded-lg"
                    pattern={specialCharRegExp}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10">
          <Button
            onClickHandler={handleFinalNext}
            disabled={checkStatus()}
            isLoading={isLoading}
            className={clsx(
              checkStatus()
                ? "px-10 py-4 mt-20 font-bold text-white rounded-lg shadow-xl bg-gray-600"
                : "px-10 py-4 mt-20 font-bold text-white transition-all rounded-lg shadow-xl hover:bg-white hover:text-primary bg-primary hover:border-2 hover:border-primary",
            )}
          >
            Next
          </Button>
          <div className="mt-2 font-bold text-red-500">
            {errorMessage === "" ? "" : errorMessage}
          </div>
        </div>
      </div>
      <Dialog open={finalModal} onClose={() => showFinalModal(false)}>
        <div className="px-8 py-3 font-bold text-white bg-green-600">Offline Transaction</div>
        <div className="flex flex-col items-center px-10 py-4 space-y-2">
          <span className="font-bold text-[16px]">Transaction Completed</span>
          <span className="font-bold text-[16px]">Transaction ID: {transactionID} </span>
          <div
            onClick={() => navigate("/history")}
            className="px-6 py-2 font-bold text-white rounded cursor-pointer bg-primary"
          >
            Go to History
          </div>
        </div>
      </Dialog>
    </div>
  );
};
